export const COMPONENT_NAME = 'StickyTitle';
export const LOCATION = 'location';
export const SOCIAL_ICONS = 'socialIcons';
